<template>
  <div :class="{
    'hm-teaser-box': true,
    'padded': value.padded
  }">
    <div :class="{
      'hm-teaser-header': true,
      'padded': value.padded
    }" :style="{ backgroundImage:  `url(${value.img})`}">
        <dragContainer v-model="value.goodData" :drag-bol="false"></dragContainer>
    </div>
    <div :class="{
      'hm-teaser-desc': true,
      'hidePadding': value.padded
    }">
      <div class="hm-teaser-desc-box">
        <div class="hm-teaser-desc__title">
          {{value.title}}
        </div>
        <div class="hm-teaser-desc__handle">
          <span class="text">{{value.cta.desc}}</span>
          <span class="icon">
            <i class="el-icon-arrow-right"></i>
          </span>
        </div>
      </div>
      <div class="hm-teaser-desc__text">
        {{value.content}}
      </div>
    </div>
  </div>
</template>
<script>
import config from './config'
import dragContainer from './dragContainer'
export default {
  name: "HmTeaser",
  wgtName: 'HmTeaser',
  wgtDesc: 'teaser',
  wgtIcon: 'wgt-search',
  config: config,
  props: {
    value: [Object, Array]
  },
  components:{
    dragContainer
  },
}
</script>
<style scoped lang="scss">
.hm-teaser-box{
  &.padded{
    padding: 64px 56px;
  }
  .hm-teaser-header{
    height: 562px;
    overflow: hidden;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    background-color: #666;
    &.padded{
      height: 422px;
    }
    .draggable {
      width: 87px;
      height: 16px;
      font-size: 12px;
      line-height: 16px;
      color: #000;
      text-align: center;
      cursor: pointer;
      background-color: white;
    }
  }
  .hm-teaser-desc{
    padding: 16px;
    position: relative;
    &.hidePadding{
      padding: 16px 0;
    }
    .hm-teaser-desc-box{
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
    }
    &__handle{
      flex: 0 82px;
      width: 82px;
      display: flex;
      align-items: center;
      .text{
        padding-right: 8px;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 130%; /* 18.2px */
        letter-spacing: 0.28px;
        text-transform: uppercase;
      }
      .icon{
        display: flex;
        align-items: center;
        width: 16px;
        height: 16px;
      }
    }
    &__title{
      flex: 1;
      padding-bottom: 16px;
      color: var(--Contextual-palette---Default-Headline, #000);
      /* Heading/XLarge/Mobile */
      font-family: "Noto Sans SC";
      font-size: 26px;
      font-style: normal;
      font-weight: 700;
      line-height: 100%; /* 26px */
      letter-spacing: 0.5px;
      text-transform: uppercase;
    }
    &__text{
      color: var(--Contextual-palette---Default-Interactive-default, #000);
      font-family: "Noto Sans SC";
      font-size: 11px;
      font-style: normal;
      font-weight: 400;
      line-height: 130%;
      text-decoration-line: underline;
    }
  }
}

</style>
